interface StarIconProps {
  size?: number | string;
  color?: string;
}

const StarIcon = ({ size, color = "#002035" }: StarIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? "17"}
    height={size ?? "17"}
    viewBox="0 0 17 17"
    fill="none">
    <g clipPath="url(#clip0_168_731)">
      <path
        d="M16.25 6.292L10.498 5.796L8.25003 0.5L6.00203 5.804L0.250031 6.292L4.61803 10.076L3.30603 15.7L8.25003 12.716L13.194 15.7L11.89 10.076L16.25 6.292ZM8.25003 11.22L5.24203 13.036L6.04203 9.612L3.38603 7.308L6.89003 7.004L8.25003 3.78L9.61803 7.012L13.122 7.316L10.466 9.62L11.266 13.044L8.25003 11.22Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_168_731">
        <rect width="16" height="16" fill="white" transform="translate(0.25 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default StarIcon;
